import { Box, Input, Spinner } from '@chakra-ui/react';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  isLoading: boolean;
  placeholder?: string;
}

const SearchBox = ({
  value,
  onChange,
  onSearch,
  isLoading,
  placeholder = 'Ask a question...',
}: SearchBoxProps): React.JSX.Element => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim()) {
      onSearch();
    }
  };

  return (
    <Box as="form" position="relative" width="100%" maxW="600px" mx="auto" onSubmit={handleSubmit}>
      <Box
        position="absolute"
        left={4}
        top="50%"
        transform="translateY(-50%)"
        color="gray.400"
        zIndex={1}
      >
        {isLoading ? <Spinner size="sm" /> : <FiSearch size={20} />}
      </Box>
      <Input
        type="search"
        inputMode="search"
        enterKeyHint="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        size="lg"
        pl={12}
        pr={4}
        py={6}
        fontSize="lg"
        borderRadius="full"
        boxShadow="lg"
        border="1px solid"
        borderColor="gray.200"
        _dark={{
          borderColor: 'gray.600',
          bg: 'gray.800',
        }}
        _hover={{
          borderColor: 'blue.300',
        }}
        _focus={{
          borderColor: 'blue.500',
          boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
        }}
      />
    </Box>
  );
};

export default SearchBox;
